import { render } from "./FormPqrs.vue?vue&type=template&id=a631d066"
import script from "./FormPqrs.vue?vue&type=script&lang=js"
export * from "./FormPqrs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\puerto-antioquia-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__